import { Component, Input } from '@angular/core'

@Component({
  selector: 'hs-panel-card',
  styleUrls: ['./panel-card.component.scss'],
  templateUrl: './panel-card.component.html',
})
export class PanelCardComponent {
  @Input() header?: string
  @Input() isLoading?: boolean
  @Input() icon?: string
  @Input() iconClass?: string
}
